<template>
  <ul class="tabs">
    <li
      v-for="tab in tabs"
      :key="tab.name"
      :class="{'active' : tab.id === current}"
      @click="displayTab(tab.id)">
      {{tab.name}}
    </li>
  </ul>
</template>

<script>
import { Component, Prop, Vue } from 'vue-property-decorator'

@Component({
  name: 'Tabs',
  props: ['tabs', 'current'],
  components: {}
})
class Tabs extends Vue {
  @Prop tabs
  @Prop current

  displayTab(tabId) {
    this.$emit('changeDisplayedTab', tabId)
  }
}

export default Tabs
</script>

<style lang="less" scoped>
.tabs {
  display: flex;
  justify-content: center;
  list-style: none;

  margin-bottom: var(--margin--large);
  padding-top: var(--margin--medium);
  padding-bottom: 6px;

  border-bottom: 1px solid #eee;

  li {
    margin: 0 20px;
    padding-bottom: 5px;
    margin-bottom: -8px;
    cursor: pointer;
    font-size: 18px;
    line-height: 21px;
    text-decoration: none;

    &.active {
      color: var(--color-main);
      border-bottom: 3px solid var(--color-main);
    }
  }
}
</style>
